import ContinentCard from './ContinentCard';
export default ContinentCard;



// WEBPACK FOOTER //
// ./src/components/Continent/ContinentCard/index.js